<template>
  <Slideover :visible="visible">
    <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
      <div class="flex items-start justify-between space-x-3">
        <h2 class="text-lg leading-7 font-medium">
          {{ title }}
        </h2>
        <div class="h-7 flex items-center">
          <button
            type="button"
            aria-label="Close panel"
            @click="close()"
            class="text-green-300 hover:text-white transition ease-in-out duration-150"
          >
            <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
          </button>
        </div>
      </div>
    </header>

    <!-- Main -->
    <div class="flex flex-col py-3 px-2 mx-4">
      <div class="mb-3">
        <label class="block leading-5"> Process Order Number: </label>
        <div class="mt-1 text-sm">
          {{ itemToBeProcessed.SourceOrderNumber }}
        </div>
      </div>
    </div>

    <HttpError class="overflow-" :error="error" />

    <!-- Footer -->
    <div class="flex justify-end px-4 py-4 space-x-4">
      <span class="inline-flex rounded-md shadow-sm">
        <button
          type="button"
          @click="close"
          class="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
        >
          Cancel
        </button>
      </span>
      <span class="inline-flex rounded-md shadow-sm">
        <Button
          @click-handler="process"
          :disabled="!canProcess || processing"
          class="flex items-center space-x-2"
        >
          <span>Process</span>
          <LoadingSpinner v-if="processing" class="text-white" />
        </Button>
      </span>
    </div>
  </Slideover>
</template>
<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Button from "@/components/elements/Button.vue";
import Slideover from "@/components/layout/Slideover.vue";

const Reports = ApiFactory.get("reports");

export default {
  name: "ProcessOrder",
  components: {
    Button,
    Slideover,
  },
  props: {
    title: {
      type: String,
      default: "Title",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    itemToBeProcessed: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      processing: false,
    };
  },
  computed: {
    canProcess() {
      return true;
    },
  },
  watch: {},
  created() {
    this.error = null;
  },
  methods: {
    process() {
      this.processing = true;
      Reports.updateUnprocessedOrders({
        sourceOrderNumber: this.itemToBeProcessed.SourceOrderNumber,
      })
        .then(this.handleSuccess)
        .catch((error) => (this.error = error))
        .finally(() => (this.processing = false));
    },
    close() {
      this.error = null;
      this.$emit("toggle-slideover");
    },
    handleSuccess() {
      this.$emit("refresh-orders");
      this.close();
    },
  },
};
</script>
